import { createContext } from 'react';

interface AuthContextType {
	isUserLoading: boolean;
	user: any;
	setUser: any;
	loggedIn: boolean;
	login: () => void;
	logout: () => void;
	permissions: string[];
	hasPermission: (permission: string) => boolean;
}

const authContext = createContext<AuthContextType | undefined>(undefined);

export default authContext;
